import { FunctionComponent } from 'react';
import { ContentCard } from '../ContentCard/ContentCard';

export interface SectionHeaderProps {
  title: string;
  padding?: string;
  headingClassName?: string;
}

export const SectionHeader: FunctionComponent<SectionHeaderProps> = ({
  title,
  padding = 'p-5',
  headingClassName = 'py-1',
}) => {
  return (
    <ContentCard padding={padding}>
      <h2 className={`text-action-link text-4xl font-bold ${headingClassName}`}>
        {title}
      </h2>
    </ContentCard>
  );
};
